import "./css/index.scss";

import React, { useCallback } from "react";

import { Theme } from "../../../../constants";
import animationData from "./animations/content-loader.animation.json";
import lottie from "lottie";

const SPINNER_ID = `${Theme.SportsIllustrated}-content-preloader`.toLowerCase();

const SISpinner = () => {
  const elemRef = useCallback(node => {
    if (node !== null) {
      lottie.loadAnimation({
        container: document.getElementById(SPINNER_ID),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData
      });
    }
  }, []);

  return <div id={SPINNER_ID} className={SPINNER_ID} ref={elemRef} />;
};

export default SISpinner;
